"use client";

import { Layout } from 'antd';
import styles from './HowStart.module.scss';
import { ScrollReveal } from '@/shared/ui/ScrollReveal';
import { useTranslations } from 'next-intl';

const { Content } = Layout;

const howStartData = [
  {
    id: 1,
    title: 'title1',
    desc: 'desc1',
  },
  {
    id: 2,
    title: 'title2',
    desc: 'desc2',
  },
  {
    id: 3,
    title: 'title3',
    desc: 'desc3',
  },
];

export const HowStart = () => {
  const t = useTranslations('musicPlayer.howStart');

  return (
    <Content className={styles.root}>
      <ScrollReveal>
        <h1>{t("title")}</h1>
      </ScrollReveal>

      <div className={styles.root_instr}>
        {howStartData.map((item) => (
          <ScrollReveal key={item.id}
            className={`
                ${styles.root_instr_item} 
                ${item.id % 2 === 0 && styles.right}
              `}
          >
            <div className={styles.root_instr_text}>
              <div className={styles.root_instr_text_count}>
                {String(item.id).padStart(2, '0')}
              </div>
              <h3>{t(item.title)}</h3>
              <h6>{t(item.desc)}</h6>
            </div>
            <div className={styles.root_instr_photo} />
          </ScrollReveal>
        ))}
      </div>
    </Content>
  );
};
